import { useEffect, useSyncExternalStore } from 'react';

// Screens a rep is mid-flow on (a badge scan, a capture, a brief and its outcomes) hold back the
// "New version ready" toast so it never lands over the camera or a half-logged conversation.
// A held screen left untouched this long counts as idle, and the toast can show.
export const UPDATE_IDLE_MS = 60_000;
let holds = 0;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());
const subscribe = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };
const snapshot = () => holds > 0;

export function useHoldPwaUpdate(active = true) {
  useEffect(() => {
    if (!active) return;
    holds++;
    notify();
    return () => { holds--; notify(); };
  }, [active]);
}

export const usePwaUpdateHeld = () => useSyncExternalStore(subscribe, snapshot, () => false);
